import {fetchRemoteResult} from '../../../Core/Api/api-util';
import securityApi from '../../../Core/Util/security';

const apiControllerEndpoint = '/api/PushNotifications/';

const validatePushNotificationsPermission = (grantType) => {
    return securityApi.validatePermission(securityApi.Permissions.PushNotificationsManage, grantType);
};

export default {
    listNotifications(){
        return fetchRemoteResult(apiControllerEndpoint);
    },
    sendPushNotification(model){
        return fetchRemoteResult(apiControllerEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        })
    },
    cancelNotification(id){
        return fetchRemoteResult(`${apiControllerEndpoint}${id}`, {
            method: 'DELETE'
        });
    },

    validateReadPermission(){
        return validatePushNotificationsPermission(securityApi.PermissionGrantTypes.Read);
    },
    validateWritePermission(){
        return validatePushNotificationsPermission(securityApi.PermissionGrantTypes.Write);
    }
}
